import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { GetProductCommentsViewModelPaginationViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

import { COMMENTS_PAGE_SIZE } from '../_components/ugc-get/constants'

export const useGetComments = (id: string, pageNumber: number) => {
    return useQuery<GetProductCommentsViewModelPaginationViewModel>({
        queryKey: QueryKeys.PDP.Comments(id, pageNumber),
        queryFn: () =>
            fetchRequest({
                serviceName: 'cml',
                method: 'GET',
                endpoint: `/products/id/${id}/comments?page_number=${pageNumber}&page_size=${COMMENTS_PAGE_SIZE}`,
            }),
        enabled: !!id,
        staleTime: Infinity,
        placeholderData: keepPreviousData,
    })
}
